import React from "react";
import PolicyLayout from "../../../components/PolicyLayout";
import s from "../../../styles/PolicyLayout.module.css";

export default function WhitenoisePrivacy() {
  return (
    <PolicyLayout
      title="privacy policy"
      appName="White Noise: Calm Sleep"
      date="NOVEMBER 2025"
    >
      {/* Intro */}
      <p>
        This Privacy Policy explains how White Noise: Calm Sleep (“we”, “our”,
        “us”, or “the Application”) collects, uses, and protects information
        when you use our mobile application. By downloading or using the
        Application, you consent to the practices described in this Policy.
      </p>

      {/* 1. Information We Collect */}
      <div className={s.title}>1) Information We Collect</div>

      <p>
        <strong>User-Provided Data.</strong> The Application does not require
        registration and does not collect personal identifiers (such as name,
        email, or phone number) unless voluntarily provided through support
        requests.
      </p>

      <p>
        <strong>Automatically Collected Data.</strong> We may automatically
        collect:
      </p>
      <ul>
        <li>Device information (model, OS version, language settings).</li>
        <li>Usage data (features used, app opens, session duration).</li>
        <li>IP address, crash reports, and diagnostic logs.</li>
      </ul>

      <p>
        <strong>Payment Data.</strong> Subscription purchases (PRO access to
        premium sounds and timer) are processed exclusively through the Apple
        App Store and Google Play. We do not collect or store your payment card
        details.
      </p>

      <p>
        <strong>Third-Party Services.</strong> We may use third-party tools such
        as:
      </p>
      <ul>
        <li>Firebase Analytics / Crashlytics (app performance and crash reporting).</li>
        <li>RevenueCat (subscription management).</li>
      </ul>
      <p>
        These services may collect limited technical and usage data as described
        in their own privacy policies.
      </p>

      {/* 2. How We Use Information */}
      <div className={s.title}>2) How We Use Information</div>
      <p>We use collected information to:</p>
      <ul>
        <li>
          Provide and improve the Application’s functionality (white noise,
          sleep sounds, timer).
        </li>
        <li>Monitor performance, fix technical issues, and ensure stability.</li>
        <li>Manage subscriptions and verify purchases.</li>
        <li>Comply with legal obligations.</li>
      </ul>

      {/* 3. Legal Basis for Processing (GDPR) */}
      <div className={s.title}>3) Legal Basis for Processing (GDPR)</div>
      <p>For users in the EEA, we process personal data under:</p>
      <ul>
        <li>
          <strong>Performance of a contract</strong>: to provide the services
          you request.
        </li>
        <li>
          <strong>Consent</strong>: for optional analytics or certain
          third-party tools.
        </li>
        <li>
          <strong>Legitimate interest</strong>: to improve the Application and
          ensure security.
        </li>
        <li>
          <strong>Legal obligation</strong>: where necessary to comply with
          applicable laws.
        </li>
      </ul>

      {/* 4. Data Retention */}
      <div className={s.title}>4) Data Retention</div>
      <p>
        We retain technical and usage data only as long as necessary for the
        purposes stated in this Policy.
      </p>
      <p>
        Payment and subscription data is managed by the App Store and Google
        Play in accordance with their policies.
      </p>
      <p>No sound recordings or personal audio content are collected or stored.</p>

      {/* 5. Sharing and Disclosure */}
      <div className={s.title}>5) Sharing and Disclosure</div>
      <p>
        We do not sell or rent your personal information. Data may be shared
        only:
      </p>
      <ul>
        <li>
          With trusted third-party service providers (analytics, subscriptions)
          under confidentiality agreements.
        </li>
        <li>
          When required by law, court order, or government authority.
        </li>
        <li>
          In connection with a merger, acquisition, or sale of assets, subject
          to appropriate safeguards.
        </li>
      </ul>

      {/* 6. International Data Transfers */}
      <div className={s.title}>6) International Data Transfers</div>
      <p>
        Your data may be transferred to servers outside your country of
        residence. We ensure such transfers comply with GDPR safeguards (for
        example, Standard Contractual Clauses).
      </p>

      {/* 7. User Rights */}
      <div className={s.title}>7) User Rights</div>

      <p>
        <strong>Under GDPR (EEA Users):</strong>
      </p>
      <ul>
        <li>Right to access, correct, or delete personal data.</li>
        <li>Right to restrict or object to processing.</li>
        <li>Right to withdraw consent at any time.</li>
        <li>Right to request data portability.</li>
        <li>
          Right to lodge a complaint with a Data Protection Authority.
        </li>
      </ul>

      <p>
        <strong>Under CCPA (California Users):</strong>
      </p>
      <ul>
        <li>Right to know what personal information is collected.</li>
        <li>Right to request deletion of personal information.</li>
        <li>
          Right to opt out of the sale of data (we do not sell personal data).
        </li>
        <li>
          Right to non-discrimination for exercising privacy rights.
        </li>
      </ul>

      <p>Requests may be submitted via our contact email listed below.</p>

      {/* 8. Children’s Privacy */}
      <div className={s.title}>8) Children’s Privacy</div>
      <p>
        The Application is not directed to children under 13 (or 16 in some
        jurisdictions). We do not knowingly collect personal information from
        children.
      </p>

      {/* 9. Data Security */}
      <div className={s.title}>9) Data Security</div>
      <p>
        We apply industry-standard technical and organizational measures,
        including encryption and secure storage, to protect your data. However,
        no method of transmission over the Internet or electronic storage is
        100% secure.
      </p>

      {/* 10. Changes to This Privacy Policy */}
      <div className={s.title}>10) Changes to This Privacy Policy</div>
      <p>
        We may update this Privacy Policy from time to time. Changes will be
        effective once published in the Application or on the official store
        page.
      </p>

      {/* 11. Contact Us */}
      <div className={s.title}>11) Contact Us</div>
      <p>
        If you have any questions or requests regarding this Privacy Policy,
        please contact:
      </p>
      <p>Developer: Nurzhan Sabyrzhan Kyzy</p>
      <p>Email: alexwadek@gmail.com</p>
    </PolicyLayout>
  );
}
